export default __webpack_public_path__ + "static/media/checked-icon.d5a52646.svg";